import {requestGet, requestPost} from "./http"
import {apiPath} from "@/util/utils";

export default {
  async productInfo(data) {
    return await requestGet(`/front/${apiPath}/findModelByCode`, data);
  },
  async registerDevice(data) {
    return await requestPost(`/front/${apiPath}/userRegisterDevice`, data);
  },
  async uploadScanRecord( currentBattery,currentSeconds,maxSeconds, tag,cartridgeMac = null) {
    const data = await requestPost(`/front/${apiPath}/uploadScanRecord`, {
      currentBattery,
      currentSeconds,
      maxSeconds,
      tag,
      cartridgeMac,
    })
  },
  async activationTag(tag) {
    const data = await requestGet(`/front/usvUser/activationTag`, {tag})
    return data
  }
}

